import React, {useEffect, useRef, useState} from 'react';
import {Map, MapMarker, Polygon} from 'react-kakao-maps-sdk';
import {markerdata} from './data';
import {flagimg} from '../../../config/images';
import {CourseTitle} from './style';
import * as S from './style';

const MapCourseTen = ({lat = 34.93667792556755, lng = 127.50636581811486}) => {
	const [map, setMap] = useState(null);

	useEffect(() => {
		const {kakao} = window;
		const mapContainer = document.getElementById('mapten'); // 지도를 표시한 곳
		const location = new kakao.maps.LatLng(lat, lng);

		const mapOptions = {
			// 지도의 옵션
			center: location, //지도의 중심좌표.
			level: 5, //지도의 레벨(확대, 축소 정도)
		};

		//지도 생성
		const kakaoMap = new kakao.maps.Map(mapContainer, mapOptions);

		//마커 이미지
		const myMarker = flagimg,
			myMarkerSize = new window.kakao.maps.Size(30, 30),
			myMarkerOption = {offset: new window.kakao.maps.Point(4, 30)};

		const myMarkerPosition = new window.kakao.maps.MarkerImage(
			myMarker,
			myMarkerSize,
			myMarkerOption,
		);

		//마커 여러개 표시
		markerdata.forEach((el, i) => {
			//출발, 도착 깃발 마커
			if (i == 0) {
				var marker = new kakao.maps.Marker({
					map: kakaoMap,
					position: new kakao.maps.LatLng(el.lat, el.lng),
					image: myMarkerPosition,
				});
				marker.setMap(kakaoMap);
			} else {
				//일반 반환마커
				var originmarker = new kakao.maps.Marker({
					map: kakaoMap,
					position: new kakao.maps.LatLng(el.lat, el.lng),
				});
				originmarker.setMap(kakaoMap);
			}
			var customOverlay = new kakao.maps.CustomOverlay({
				position: new kakao.maps.LatLng(el.lat, el.lng),
				content: `<div class ="label" style="margin: -55px auto;"><span class="left"></span><span class="center" style="color: black; background-color: white; border-radius: 7px; padding: 1px 10px;  border: solid 2px #d9d9d9;
">${el.title}</span><span class="right"></span></div></div>`,
			});
			var textOverlay = new kakao.maps.CustomOverlay({
				position: new kakao.maps.LatLng(34.936740, 127.513166),
				content: '<div style="padding:2px; background-color:#f5f5f5; border: 2px solid #4489c5ff; border-radius:5px; font-size: 13px;">갈 때만 이용</div>',
				zIndex: 3,
			});

			customOverlay.setMap(kakaoMap);
			textOverlay.setMap(kakaoMap);
		});

		//컨트롤 표시
		var mapTypeControl = new kakao.maps.MapTypeControl();
		kakaoMap.addControl(
			mapTypeControl,
			kakao.maps.ControlPosition.TOPRIGHT,
		);

		// 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
		var zoomControl = new kakao.maps.ZoomControl();
		kakaoMap.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

		//지도 범위 핀 다 보이게 재설정

		//폴리 라인 그리기
		const linePath = [
			new kakao.maps.LatLng(34.93824533293566, 127.51941208098545), //팔마종합운동장
			new kakao.maps.LatLng(34.937598321503366, 127.51894827556737),
			new kakao.maps.LatLng(34.93688601670695, 127.51899851768951),
			new kakao.maps.LatLng(34.93484871855129, 127.51904041201075),
			// new kakao.maps.LatLng(34.93479017716624, 127.5190290977428), // 올때만 이용

			// new kakao.maps.LatLng(34.935662028260026, 127.51537875735843), // 갈때만 이용하는 길
			// new kakao.maps.LatLng(34.936508261472135, 127.51350138689611),
			// new kakao.maps.LatLng(34.93640952856763, 127.51340226016139),
			// new kakao.maps.LatLng(34.93547241836272, 127.51545419039184),
			// new kakao.maps.LatLng(34.93465525428691, 127.5189625749953),

			new kakao.maps.LatLng(34.934699994799516, 127.5190394751353),
			// new kakao.maps.LatLng(34.93558964114086, 127.51544397815061),
			// new kakao.maps.LatLng(34.936490835670874, 127.51335898394301),
			// new kakao.maps.LatLng(34.93558964114086, 127.51544397815061),
			// new kakao.maps.LatLng(34.934699994799516, 127.5190394751353),

			// new kakao.maps.LatLng(34.93438866546061, 127.52017583928776), // 사거리로 쭉 나오는 길
			// new kakao.maps.LatLng(34.934188163581915, 127.52068900770946),
			// new kakao.maps.LatLng(34.933734575493254, 127.52136475295976),
			new kakao.maps.LatLng(34.93448889217353, 127.51992472670887), 
			new kakao.maps.LatLng(34.93417238688551, 127.5201635284935),
			new kakao.maps.LatLng(34.93402349912809, 127.52020089743351),
			new kakao.maps.LatLng(34.933852382067116, 127.52016698102369),
			new kakao.maps.LatLng(34.933690887606886, 127.51999083604403),
			new kakao.maps.LatLng(34.93339129764623, 127.51943620761327),

			new kakao.maps.LatLng(34.93164141679255, 127.5122889892901),
			new kakao.maps.LatLng(34.92957731134659, 127.4970847677337), // 서문삼거리
			new kakao.maps.LatLng(34.93554077631377, 127.49577990707995),
			new kakao.maps.LatLng(34.935944175782645, 127.49632414446593),
			new kakao.maps.LatLng(34.936087431637375, 127.49656033945658),
			new kakao.maps.LatLng(34.93664506902983, 127.49795928329033),
			new kakao.maps.LatLng(34.93702075313858, 127.49976213767779),

			new kakao.maps.LatLng(34.9369834602296, 127.50006292074661), // 로타리
			new kakao.maps.LatLng(34.936892806220975, 127.50018824698448),
			new kakao.maps.LatLng(34.93690583083638, 127.50030872965708),
			new kakao.maps.LatLng(34.93696417120546, 127.50036928577526),
			new kakao.maps.LatLng(34.93705870112952, 127.50039722439175),
			new kakao.maps.LatLng(34.93717188931022, 127.5002720349667),

			new kakao.maps.LatLng(34.93740608471862, 127.50031176752117),
			new kakao.maps.LatLng(34.937464785694075, 127.50028475935639),
			new kakao.maps.LatLng(34.941300181280134, 127.49808593929356),
		];
		const lineDashPath = [
			new kakao.maps.LatLng(34.934699994799516, 127.5190394751353),
			new kakao.maps.LatLng(34.93558964114086, 127.51544397815061),
			new kakao.maps.LatLng(34.936490835670874, 127.51335898394301),
			new kakao.maps.LatLng(34.93558964114086, 127.51544397815061),
			new kakao.maps.LatLng(34.934699994799516, 127.5190394751353),
		];

		var polyline = new kakao.maps.Polyline({
			path: linePath,
			strokeWeight: 5,
			strokeColor: '#005bac',
			strokeOpacity: 1,
			strokeStyle: 'solid',
		});
		var polyline_dash = new kakao.maps.Polyline({
			path: lineDashPath,
			strokeWeight: 3,
			strokeColor: '#4489c5ff',
			strokeOpacity: 1,
			strokeStyle: 'dash',
		});

		polyline.setMap(kakaoMap);
		polyline_dash.setMap(kakaoMap);
	}, []);

	return (
		<>
			<CourseTitle>10km</CourseTitle>
			<div
				id='mapten'
				style={{
					width: '100%',
					height: '650px',
				}}
			></div>
		</>
	);
};

export default MapCourseTen;
